/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Toast_Sent2Inputs */

const en_coinvestments_senddrafts_toast_sent2 = /** @type {(inputs: Coinvestments_Senddrafts_Toast_Sent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts sent`)
};

/**
* | output |
* | --- |
* | "Drafts sent" |
*
* @param {Coinvestments_Senddrafts_Toast_Sent2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_toast_sent2 = /** @type {((inputs?: Coinvestments_Senddrafts_Toast_Sent2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Toast_Sent2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_toast_sent2(inputs)
});
export { coinvestments_senddrafts_toast_sent2 as "coInvestments_sendDrafts_toast_sent" }